// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-spacer {
  color: #055C8D;
  padding-left: 18px;
  font-size: 17px;
}

.toolbar-header {
  height: 41px;
  font-family: Inter !important;
}

.main-content {
  background-color: #f3f3f3;
}

.notification-button {
  margin: 0 0 0 auto;
}

mat-toolbar {
  background-color: #ffffff;
  padding-right: 5%;
  display: flex;
  z-index: 990;
  height: 70px;
  color: #055C8D;
}

.toolbar-headings {
  margin-left: 57.5px;
  justify-content: space-between;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 230px;
}

a {
  color: #B2B2B2;
}

.active-heading {
  color: #055C8D;
}

.routing-container {
  padding-left: 25.5px;
  padding-right: 0px;
  min-width: 430px;
  min-height: 640px;
  width: 100%;
}

.link {
  cursor: pointer;
  color: #055C8D;
}

.link:hover {
  cursor: pointer;
  color: #053551;
}

.mat-icon {
  color: #055C8D;
  background-color: #fff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
